import * as React from 'react'

export const GitIcon = React.forwardRef<
  SVGSVGElement,
  {
    color?: string
    width?: number
    height?: number
  } & React.SVGProps<SVGElement>
>(({ width = 15, height = 15, ...props }, ref) => {
  return (
    <svg
      {...props}
      ref={ref}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 15 15"
    >
      <path
        d="M13.755 7.421 8.08 1.745a.837.837 0 0 0-1.184 0l-1.179 1.18 1.495 1.494a.994.994 0 0 1 1.26 1.268l1.44 1.44a.994.994 0 0 1 1.03 1.646.997.997 0 0 1-1.626-1.084L7.971 6.346v3.536a.996.996 0 1 1-.82-.03V6.285a.997.997 0 0 1-.54-1.307L5.137 3.503 1.245 7.394a.838.838 0 0 0 0 1.185l5.676 5.676a.838.838 0 0 0 1.184 0l5.65-5.65a.838.838 0 0 0 0-1.184Z"
        fill="currentColor"
      />
    </svg>
  )
})
